import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, MessageCircle, Calendar } from 'lucide-react';
import { company } from '../../mock';

const waLink = `https://wa.me/${company.whatsapp}?text=${encodeURIComponent('Hi Ewen Realtors, I would like to book a site visit.')}`;

export default function StickyMobileBar() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return null;

  return (
    <div data-testid="sticky-mobile-bar" className="fixed bottom-0 inset-x-0 z-40 md:hidden pb-[env(safe-area-inset-bottom)]">
      <div className="grid grid-cols-3 border-t border-white/10 bg-[#0f1a14]/95 backdrop-blur">
        <a data-testid="sticky-call-btn" href={`tel:${company.phoneRaw}`} className="flex flex-col items-center justify-center gap-1 py-3 text-white/85 active:bg-white/10">
          <Phone className="h-4 w-4 text-[#c9a56a]" />
          <span className="text-[10px] uppercase tracking-widest">Call</span>
        </a>
        <a data-testid="sticky-whatsapp-btn" href={waLink} target="_blank" rel="noreferrer" className="flex flex-col items-center justify-center gap-1 py-3 text-white/85 border-x border-white/10 active:bg-white/10">
          <MessageCircle className="h-4 w-4 text-[#25D366]" />
          <span className="text-[10px] uppercase tracking-widest">WhatsApp</span>
        </a>
        <Link data-testid="sticky-book-visit-btn" to="/contact" className="flex flex-col items-center justify-center gap-1 py-3 bg-[#c9a56a] text-[#0f1a14] font-medium active:bg-[#b8945a]">
          <Calendar className="h-4 w-4" />
          <span className="text-[10px] uppercase tracking-widest">Book Visit</span>
        </Link>
      </div>
    </div>
  );
}

